import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import "../../../../styles/HomeScreen.css";
import colors from "assets/colors";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { getStorageItem } from "utils/v4-utils/localStorage";
// import greeter from 'utils/v4-utils/greeter';
// import { getStorageItem } from 'utils/v4-utils/localStorage';

// export const HotelDateAndLicense = () => {
//     const store = useSelector((store: any) => store);
//     const appLocation = useLocation();
//     const navigate = useNavigate();
//     const pathname = appLocation.pathname;
//     const hotelDate = getStorageItem("hotelDate");
//     const defaultData = {licenseDetails: "License Okay", hotelDate: new Date().toDateString()};
//     const { userDetails } = store;
//     const { licenseDetails } = typeof(userDetails) === "object" ? userDetails.userDetails : defaultData;
//     useEffect(() => {
//         if(pathname === "/"){
//           navigate("/login")
//         }
//       }, [])
//     return (
//         <React.Fragment>
//             {
//                 licenseDetails &&
//                 <Grid sx={{ml:1, mt:.25}} container spacing={3}>
//                     <Grid justifyContent="center" alignItems="center" sx={{py:.25, px:1, mx:1, display: "flex"}} style={{borderRadius: "3px", backgroundColor: licenseDetails.includes("expiration") ? colors.danger : colors.white}} className={`box_shadow `}>
//                         <Stack direction="row" sx={{color: licenseDetails.includes("expiration") ? colors.black : colors.black}} style={{fontWeight: "bold", textAlign: "center", fontSize: licenseDetails.includes("expiration") ? "18px" : "13px"}} className={licenseDetails.includes("expiration") ? "animate__animated animate__infinite animate__flash animate__slower 5s" : undefined}>
//                             {licenseDetails}
//                         </Stack>
//                     </Grid>
//                     <Grid justifyContent="center" alignItems="center" sx={{ fontWeight: "bold", p:1, backgroundColor: licenseDetails.includes("expiration") ? colors.danger : colors.white, color: licenseDetails.includes("expiration") ? colors.black : colors.black}} style={{borderRadius: "3px"}} className={`box_shadow`}>
//                         <Stack direction="row" justifyContent="center" alignItems="center">
//                             Hotel Date:
//                         </Stack>
//                         <Stack sx={{}} direction="row" justifyContent="center" alignItems="center">
//                             {hotelDate}
//                         </Stack>
//                     </Grid>
//                 </Grid>
//             }
//         </React.Fragment>
//     )
// };
export const HotelDateAndLicense = () => {
  // Select only the needed slice of state
  const userDetails = useSelector((state: any) => state.userDetails);

  const appLocation = useLocation();
  const navigate = useNavigate();
  const pathname = appLocation.pathname;

  // Retrieve hotel date from storage
  const hotelDate = getStorageItem("hotelDate");
  const defaultData = {
    licenseDetails: "License Okay",
    hotelDate: new Date().toDateString(),
  };

  // Safely access licenseDetails with fallback
  const licenseDetails =
    userDetails?.userDetails?.licenseDetails || defaultData.licenseDetails;

  useEffect(() => {
    if (pathname === "/") {
      navigate("/login");
    }
  }, [pathname, navigate]);

  return (
    <React.Fragment>
      {licenseDetails && (
        <Grid sx={{ ml: 1, mt: 0.25 }} container spacing={3}>
          <Grid
            justifyContent="center"
            alignItems="center"
            sx={{ py: 0.25, px: 1, mx: 1, display: "flex" }}
            style={{
              borderRadius: "3px",
              backgroundColor: licenseDetails.includes("expiration")
                ? colors.danger
                : colors.white,
            }}
            className="box_shadow"
          >
            <Stack
              direction="row"
              sx={{
                color: licenseDetails.includes("expiration")
                  ? colors.black
                  : colors.black,
              }}
              style={{
                fontWeight: "bold",
                textAlign: "center",
                fontSize: licenseDetails.includes("expiration")
                  ? "18px"
                  : "13px",
              }}
              className={
                licenseDetails.includes("expiration")
                  ? "animate__animated animate__infinite animate__flash animate__slower 5s"
                  : undefined
              }
            >
              {licenseDetails}
            </Stack>
          </Grid>
          <Grid
            justifyContent="center"
            alignItems="center"
            sx={{
              fontWeight: "bold",
              p: 1,
              backgroundColor: licenseDetails.includes("expiration")
                ? colors.danger
                : colors.white,
              color: licenseDetails.includes("expiration")
                ? colors.black
                : colors.black,
            }}
            style={{ borderRadius: "3px" }}
            className="box_shadow"
          >
            <Stack direction="row" justifyContent="center" alignItems="center">
              Hotel Date:
            </Stack>
            <Stack direction="row" justifyContent="center" alignItems="center">
              {hotelDate}
            </Stack>
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
};

export const Greeter = () => {
  // const fullname = getStorageItem("fullname");
  // const userType = getStorageItem("userType");
  return (
    <>
      <Box component="span" style={{}}>
        {new Date().getDay() === 5 && (
          <Typography
            variant="h5"
            component="span"
            className=" mx-2"
            style={{
              flexDirection: "column",
              display: "flex",
              color: colors.black,
              textAlign: "center",
            }}
          >
            Thank God it's Friday
          </Typography>
        )}
      </Box>
    </>
  );
};
